import
{
  styled,
  Collapse,
  IconButton,
  Stack,
} from '@mui/material';
import { colors } from '../../../options/colors';
import { Close } from '@mui/icons-material';

export const StyledCollapse = styled(Collapse)(() => ({}));

export const StyledAlert = styled(Stack)(({ success, fixed }) => ({
  padding: 5,
  borderRadius: fixed ? '0px 0px 3px 3px' : 2,
  backgroundColor: success ? colors.successLightGreen : colors.secondaryRed,
  '.MuiAlert-message': {
    padding: 0,
  },
  '.MuiAlert-action': {
    padding: '0 0 0 5px',
  },
}));

export const StyledIconButton = styled(IconButton)(() => ({
  padding: 2,
}));

export const StyledCloseIcon = styled(Close)(({ success }) => ({
  color: success ? colors.successDarkGreen : colors.primaryRed,
  fontSize: 22,
}));

export const TextContainer = styled('div')(({ button }) => ({
  marginBottom: button ? 17 : 0,
}));
